import { render, staticRenderFns } from "./AamsLicenseRegUsageApproval.vue?vue&type=template&id=68d61178&scoped=true&"
import script from "./AamsLicenseRegUsageApproval.vue?vue&type=script&lang=js&"
export * from "./AamsLicenseRegUsageApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d61178",
  null
  
)

export default component.exports